import React, { useContext } from 'react'
import { NavLink } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import './dashboard.css'
import { ListItem } from '@material-ui/core'
import AuthContext from '../../../Product/context/auth/authContext'

const DashboardPanel = ({ title, subtitle, savedcards, seller, invoices }) => {
    const { user } = useContext(AuthContext)
    return (
        <div className="dashboardLt">
            <ul>
                {user && user.role == 1 && (
                    <ListItem button>
                        <NavLink to="/dashboard/overview" activeClassName="active">
                            <span className="material-icons">dashboard</span>
                            Dashboard
                        </NavLink>
                    </ListItem>
                )}
                <ListItem button>
                    <NavLink activeClassName="active" to="/dashboard/profile">
                        <span className="material-icons">person</span>
                        My Account
                    </NavLink>
                </ListItem>
                {user && user.role == 1 ? (
                    <>
                        <ListItem button>
                            <NavLink activeClassName="active" to="/dashboard/mybids">
                                <span className="material-icons">gavel</span> My Bids
                            </NavLink>
                        </ListItem>
                        {global.storeConfigration?.disabled_auc_mulsel2?.value != 1 ? (
                            <ListItem button>
                                <NavLink activeClassName="active" to="/sellerdashboard">
                                    <span className="material-icons">store</span> My Auctions
                                </NavLink>
                            </ListItem>
                        ) : (
                            ''
                        )}
                        {global.storeConfigration?.need_post_buynow?.value != 0 ? (
                            <ListItem button>
                                <NavLink activeClassName="active" to="/dashboard/buynow">
                                    <span className="material-icons">shopping_basket</span> My Buy
                                    now
                                </NavLink>
                            </ListItem>
                        ) : (
                            ''
                        )}
                    </>
                ) : (
                    <ListItem button>
                        <NavLink activeClassName="active" to="/dashboard/mybids">
                            <span className="material-icons">gavel</span> My Bids
                        </NavLink>
                    </ListItem>
                )}
                {user && user.role == 1 && (
                    <ListItem button>
                        <NavLink activeClassName="active" to="/dashboard/payout_history">
                            <span className="material-icons">gavel</span> Payout History
                        </NavLink>
                    </ListItem>
                )}

                {user && user.role == 1 && global.pluginConfiguration?.make_an_offer?.enable && (
                    <ListItem button>
                        <NavLink to="/dashboard/makeanoffer" activeClassName="active">
                            <span className="material-icons">receipt</span>
                            Make An Offer
                        </NavLink>
                    </ListItem>
                )}
                <ListItem button>
                    <NavLink to="/dashboard/favorites" activeClassName="active">
                        <span className="material-icons">favorite</span>
                        My Favorites
                    </NavLink>
                </ListItem>
                {invoices && (
                    <ListItem button>
                        <NavLink to="/dashboard/transactions" activeClassName="active">
                            <span className="material-icons">receipt</span>
                            Invoices
                        </NavLink>
                    </ListItem>
                )}
                {global?.pluginConfiguration?.flutterwave_payment_gateway?.enable == 1 ||
                global?.storeConfigration?.enable_paystack?.value == 1 > 0 ? null : (
                    <ListItem button>
                        <NavLink to="/dashboard/cards" activeClassName="active">
                            <span className="material-icons">credit_card</span>
                            Saved Cards
                        </NavLink>
                    </ListItem>
                )}
                <ListItem button>
                    <NavLink to="/dashboard/savedSearch" activeClassName="active">
                        <span className="material-icons">bookmark</span>
                        Saved Search
                    </NavLink>
                </ListItem>
                <ListItem button>
                    <NavLink to="/dashboard/preference" activeClassName="active">
                        <span className="material-icons">notifications</span>
                        Preference
                    </NavLink>
                </ListItem>
                {user && user.role == 1 && (
                    <ListItem button>
                        <NavLink to="/dashboard/invoices" activeClassName="active">
                            <span className="material-icons">receipt</span>
                            Invoices
                        </NavLink>
                    </ListItem>
                )}
                {user?.role == 1 && global.pluginConfiguration?.paypal_payout?.enable == 0 && (
                    <ListItem button>
                        <NavLink to="/dashboard/payout" activeClassName="active">
                            <span className="material-icons">receipt</span>
                            Payouts
                        </NavLink>
                    </ListItem>
                )}
                {user && user.role == 0 && (
                    <ListItem button>
                        <NavLink to="/dashboard/transactions" activeClassName="active">
                            <span className="material-icons">receipt</span>
                            Transactions
                        </NavLink>
                    </ListItem>
                )}
                {user && user.role == 1 && (
                    <ListItem button>
                        <NavLink to="/dashboard/reports" activeClassName="active">
                            <span className="material-icons">description</span>
                            Reports
                        </NavLink>
                    </ListItem>
                )}
                {user && user.role == 1 && (
                    <ListItem button>
                        <NavLink to="/dashboard/photouploader" activeClassName="active">
                            <span className="material-icons">collections</span>
                            Photo Uploader
                        </NavLink>
                    </ListItem>
                )}
                {/* <ListItem button>
                    <NavLink to="/dashboard/message" activeClassName="active">
                        <span className="material-icons">question_answer</span>
                        Message
                    </NavLink>
                </ListItem> */}
                {global.pluginConfiguration?.ticketing?.enable == 1 && user && user.role == 0 && (
                    <ListItem button>
                        <NavLink to="/dashboard/mytickets" activeClassName="active">
                            <span className="material-icons">local_activity</span>
                            My Tickets
                        </NavLink>
                    </ListItem>
                )}
                {/* {user && user.role == 1 && (
                    <ListItem button>
                        <NavLink to="/onboard" activeClassName="active">
                            <span className="material-icons">payments</span>
                            Payment Gateway Onboard
                        </NavLink>
                    </ListItem>
                )} */}
                {global.pluginConfiguration?.feedback?.enable == 1 ? (
                    <ListItem button>
                        <NavLink to="/dashboard/feedback" activeClassName="active">
                            <span className="material-icons">feedback</span>
                            Feedback
                        </NavLink>
                    </ListItem>
                ) : null}
                {global.pluginConfiguration?.referral?.enable == 1 ? (
                    <ListItem button>
                        <NavLink to="/referral" activeClassName="active">
                            <span className="material-icons">share</span>
                            Referral
                        </NavLink>
                    </ListItem>
                ) : null}
                {global.pluginConfiguration?.flutterwave_payment_gateway?.enable == 1 &&
                user?.role == 1 ? (
                    <ListItem button>
                        <NavLink to="/refund" activeClassName="active">
                            <span className="material-icons">description</span>
                            Return
                        </NavLink>
                    </ListItem>
                ) : null}
                {global?.pluginConfiguration?.disputes?.enable == 1 && user?.role == 1 ? (
                    <ListItem button>
                        <NavLink to="/disputes" activeClassName="active">
                            <span className="material-icons">question_answer</span>
                            Disputes
                        </NavLink>
                    </ListItem>
                ) : null}
            </ul>
        </div>
    )
}

export default withRouter(DashboardPanel)
